const inputFormat: string = 'yyyy년 M월 d일'
const issueDateFormat: string = 'yyyyMMdd'
const confirmFormat: string = 'yyyy.MM.dd'

export {inputFormat, issueDateFormat, confirmFormat}
